import { FilterTable } from '@/components/new/table/filter/FiltersRow'
import { Banknote, Tag } from 'lucide-react'
import { ICategory } from '../interfaces/interfaces'

export const mockedData: ICategory[] = [
  {
    id: 1,
    name: 'Bebidas',
    description: 'Description 1',
    createdAt: '2025-07-01T11:00:37.837Z',
  },
]
